export default __webpack_public_path__ + "static/1-c5d73aeeee60175039a32002692a8bda.png";